<template>
	<div class="container">
		<div class="car_instant">
			<div class="item">
				<div class="tit">
					<img src='../../assets/img/tit.png' style='height:.2rem;' />
					<img src='../../assets/img/tit.png' style='height:.2rem;' />
					实时状态{{carSelInfo.carid}}
				</div>
				<div class="info">
					<div class="datachart">
						<img src='../../assets/img/instant_sta.png' class="dataimg"/>
						<div class="data">
							<div>状态</div>
							<div :class="carInfo.status == 0 ? 'fontg' : 'fontw'" >{{carInfo.status == 0 ? '在线' : '离线' }}</div>
						</div>
					</div>
					<div class="datachart">
						<img src='../../assets/img/instant_mode.png' class="dataimg" />
						<div class="data">
							<div>模式</div>
							<div :class="carInfo.driveMode == 1 ? 'fontg' : 'fontw'">{{carInfo.driveMode == 1 ? '自动' : '人工'}}</div>
						</div>
					</div>
					<div class="datachart">
						<img src='../../assets/img/instant_speed.png' class="dataimg" />
						<div class="data">
							<div>速度</div>
							<div>{{carInfo.speed}}米/秒</div>
						</div>
					</div>
				</div>
				<div class="info">
					<div class="datachart">
						<img src='../../assets/img/instant_ele.png' class="dataimg" />
						<div class="data">
							<div>电量</div>
							<div v-if="carInfo.powerLeft">{{carInfo.powerLeft.toFixed(2)}}%</div>
						</div>
					</div>
					<div class="datachart">
						<img src='../../assets/img/instant_vot.png' class="dataimg" />
						<div class="data">
							<div>电压</div>
							<div>{{carInfo.voltage}} v</div>
						</div>
					</div>
					<!-- 
					<div class="datachart">
						<img src='../../assets/img/instant_charge.png' class="dataimg" />
						<div class="data">
							<div>充电状态</div>
							<div :class="carInfo.batterySta == 1 ? 'fontg' : 'fontw'">{{carInfo.batterySta == 1 ? '在' : '不在'}}充电</div>
						</div>
					</div>
					 -->
					 <div class="datachart">
					 	<img src='../../assets/img/instant_dust.png' class="dataimg" />
					 	<div class="data">
					 		<div>震尘</div>
					 		<div :class="carInfo.switchDust == 1 ? 'fontg' : 'fontw'">{{carInfo.switchDust == 1 ? '开' : '关'}}</div>
					 	</div>
					 </div>
				</div>
				<div class="info">
					<div class="datachart">
						<img src='../../assets/img/instant_water.png' class="dataimg" />
						<div class="data">
							<div>水量</div>
							<div :class="carInfo.waterBoxLeft == 1 ? 'fontg' : 'fontw'">{{carInfo.waterBoxLeft == 1 ? '不足' : '正常' }}</div>
						</div>
					</div>
					<div class="datachart">
						<img src='../../assets/img/instant_rubbish.png' class="dataimg" />
						<div class="data">
							<div>垃圾箱</div>
							<div>{{carInfo.cleanBoxLeft}} %</div>
						</div>
					</div>
					<div class="datachart">
						<img src='../../assets/img/instant_stop.png' class="dataimg" />
						<div class="data">
							<div>急停</div>
							<div :class="carInfo.switchStop == 1 ? 'fontg' : 'fontw'">{{carInfo.switchStop == 1 ? '开' : '关' }}</div>
						</div>
					</div>
				</div>
				<div class="info">					
					<div class="datachart">
						<img src='../../assets/img/instant_led.png' class="dataimg" />
						<div class="data">
							<div>大灯</div>
							<div :class="carInfo.switchLed == 1 ? 'fontg' : 'fontw'">{{carInfo.switchLed == 1 ? '开' : '关'}}</div>
						</div>
					</div>
					<div class="datachart">
						<img src='../../assets/img/instant_brush.png' class="dataimg" />
						<div class="data">
							<div>刷盘</div>
							<div :class="carInfo.switchBrush == 1 ? 'fontg' : 'fontw'">{{carInfo.switchBrush == 1 ? '开' : '关'}}</div>
						</div>
					</div>
					<div class="datachart">
						<img src='../../assets/img/instant_sprilnk.png' class="dataimg" />
						<div class="data">
							<div>洒水</div>
							<div :class="carInfo.switchSprilink == 1 ? 'fontg' : 'fontw'">{{carInfo.switchSprilink == 1 ? '开' : '关'}}</div>
						</div>
					</div>
				</div>
				<div class="info">				
					<div class="datachart">
						<img src='../../assets/img/work_map.png' class="dataimg" />
						<div class="data">
							<div>定位</div>
							<div>{{carInfo.locateStatus == 0 ? '正常':'已丢失'}}</div>
						</div>
					</div>
					<div class="datachart">
						<img src='../../assets/img/work_map.png' class="dataimg" />
						<div class="data">
							<div>朝向解</div>
							<div>{{carInfo.orientationStatus == 0 ? '未使用':'正常'}}</div>
						</div>
					</div>
					<div class="datachart">
						<img src='../../assets/img/work_map.png' class="dataimg" />
						<div class="data">
							<div>协方差</div>
							<div>{{carInfo.covarianceStatus}}</div>
						</div>
					</div>
					<!-- 
					<div class="datachart">
						<img src='../../assets/img/instant_cpu.png' class="dataimg" />
						<div class="data">
							<div>CPU占用</div>
							<div>{{carInfo.percentCpu}}%</div>
						</div>
					</div>
					<div class="datachart">
						<img src='../../assets/img/instant_disk.png' class="dataimg" />
						<div class="data">
							<div>磁盘剩余</div>
							<div>{{carInfo.percentDisk}}%</div>
						</div>
					</div>
					 -->
				</div>
			</div>
			
			<div class="item" style="margin-top:.2rem;">
				<div class="tit">
					<img src='../../assets/img/tit.png' style='height:.2rem;' />
					<img src='../../assets/img/tit.png' style='height:.2rem;' />
					耗材使用
				</div>
				<div class="info">
					<div class="datachart" style="padding-left: .4rem;">
						<div class="data">												
							<div>主刷 / 边刷</div>
							<!-- <div class="fonto">{{carpartsavaliable.masterBrushAvailable}}小时</div> -->						
							<div v-if="carpartsavaliable && carpartsavaliable.masterBrushAvailable" class="fonto">
								{{carpartsavaliable.masterBrushAvailable.toFixed(2)}}小时	
							</div>							
						</div>
					</div>
					<!-- 
					<div class="datachart">
						<div class="data">						
							<div>边刷</div>
							<div v-if="carpartsavaliable && carpartsavaliable.edgeBrushAvailable" class="fonto">
								{{carpartsavaliable.edgeBrushAvailable.toFixed(2)}}小时	
							</div>												
						</div>
					</div>
					 -->
					<div class="datachart">
						<div class="data">						
							<div>滤芯</div>
							<!-- <div class="fonto">{{carpartsavaliable.filterAvailable}}小时</div>/\ -->
							<div v-if="carpartsavaliable && carpartsavaliable.filterAvailable" class="fonto">
								{{carpartsavaliable.filterAvailable.toFixed(2)}}小时	
							</div>					
						</div>
					</div>
					<div class="datachart">
						<div class="data">						
							<div>前 / 侧档皮</div>
							<div v-if="carpartsavaliable && carpartsavaliable.frontStallCoverAvailable" class="fonto">
								{{carpartsavaliable.frontStallCoverAvailable.toFixed(2)}}小时	
							</div>					
						</div>
					</div>					
				</div>			
			</div>
			
			<div class="item" style="margin-top:.2rem;">
				<div class="tit">
					<img src='../../assets/img/tit.png' style='height:.2rem;' />
					<img src='../../assets/img/tit.png' style='height:.2rem;' />
					告警信息
				</div>
				
				<div class="car_work" style="justify-content: space-evenly;font-size: 12px;">
					<el-scrollbar v-show="awarningList.length>0" style="width: 100%;height: 1rem;">
						<ul style="padding: inherit;color: #dd0105;">
							<li v-for="(item, index) in awarningList" :key="index" class="row" style="justify-content: space-around;line-height: 20px;">
								<div v-if="item.carName" style="width: 1.2rem;text-align: left;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{item.carName}} </div>						
								<div v-if="item.updateTime"  style="width: .8rem;text-align: left;text-overflow: ellipsis;overflow: hidden">
											{{item.updateTime.indexOf(' ') > 0 ? item.updateTime.substring(item.updateTime.indexOf(' ')) : item.updateTime}} 
								</div>
								<div v-if="item.info" style="width: 1.5rem;text-align: left;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{item.info}}</div>	
							</li>
						</ul>
						<ul style="padding: inherit;color: #F19F19;">
							<li v-for="(item, index) in bwarningList" :key="index"  class="row" style="justify-content: space-around;line-height: 20px;">
								<div v-if="item.carName" style="width: 1.2rem;text-align: left;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{item.carName}} </div>						
								<div v-if="item.updateTime"  style="width: .8rem;text-align: left;text-overflow: ellipsis;overflow: hidden">
											{{item.updateTime.indexOf(' ') > 0 ? item.updateTime.substring(item.updateTime.indexOf(' ')) : item.updateTime}} 
								</div>
								<div v-if="item.info" style="width: 1.5rem;text-align: left;;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{item.info}}</div>
							</li>
						</ul>
						<ul style="padding: inherit;color: #ebeb75;">
							<li v-for="(item, index) in cwarningList" :key="index"  class="row" style="justify-content: space-around;line-height: 20px;">
								<div v-if="item.carName" style="width: 1.2rem;text-align: left;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{item.carName}} </div>						
								<div v-if="item.updateTime"  style="width: .8rem;text-align: left;text-overflow: ellipsis;overflow: hidden">
											{{item.updateTime.indexOf(' ') > 0 ? item.updateTime.substring(item.updateTime.indexOf(' ')) : item.updateTime}} 
								</div>
								<div v-if="item.info" style="width: 1.5rem;text-align: left;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{item.info}}</div>	
							</li>
						</ul>
					</el-scrollbar>
					<!-- 
					<scroll :data="warningList" :class-option="scrollOption" class="box">
						<div v-if="warningList.length > 0">
							<div class="boxnav" v-for="(item,index) in warningList" :key="index" >
								<div v-if="item.workName" class="boxitem" style="width:1.5rem;">
									{{item.workName.indexOf('-') > 0 ? item.workName.substring(0,item.workName.indexOf('-')) : item.workName}}
								</div>
								<div v-if="item.updateTime" class="boxitem" style="width:1rem;">
									{{item.updateTime.indexOf(' ') > 0 ? item.updateTime.substring(item.updateTime.indexOf(' ')) : item.updateTime}} 
								</div>
								<div  v-if="item.info" class="boxitem" style="width:1.5rem;">{{item.info}}</div>
							</div>
						</div>
					</scroll>	
					 -->	
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	import scroll from 'vue-seamless-scroll'
	import {getIndexCarInstant,getIndexCarWarning,getIndexCarCustom} from '../../api/car.js'
	export default{
		props: {
			selectedCarInfo:{
				type:Object
			},
			mqttRealData:{
				type:Object
			},
			mqttRealOrder:{
				type:Object
			},
			mqttRealAlarm:{
				type:Object
			}
		},
		watch: {
			selectedCarInfo:{
				handler(newData) {
					if(newData != null){
						// this.carInfo.worktype='加载中...'
						// 计时器正在进行中，退出函数
						// if (this.carInfoIntervalId != null) {
						// 	return;
						// }
						// 计时器为空，操作
						// this.carInfoIntervalId = setInterval(() =>{
							if(newData.carid != null){
								this.carSelInfo = newData
								this.initCarInstant()
								this.initCarDayWarning()
								this.initCarInfo()
							}
							
						// },5*1000)
					}
				},
				immediate: true, //最初绑定值的时候也执行函数
				deep: true //监听一个对象的改变
			},
			mqttRealData:{
				handler(newData){
					if(newData != null){
						this.carInfo = newData
						
						this.handleOrientationStatus(this.carInfo)
					}
				},
				immediate: true, 
				deep: true
			},
			mqttRealOrder:{
				handler(newData){
					if(newData != null){	
						var status = newData.workStatus
						if(status == 3){
							this.mqttUpdateDataUsing(newData)
						}					
					}
				},
				immediate: true,
				deep: true 
			},
			mqttRealAlarm:{
				handler(newData){
					if(newData != null){
						this.handleRealWarn(newData)
					}
				},
				immediate: true,
				deep: true 
			}
		},
		components: {
		   scroll
		},
		mounted() {
			
		},
		destroyed() {
			// 在页面销毁后，清除计时器
			// this.clearCarInfo();
		},
		data(){
			return{	
				carSelInfo:{},
				carInfo:{},
				// carInfoIntervalId: null,
				carpartsavaliable:{},
				warningList:[],
				awarningList:[],
				bwarningList:[],
				cwarningList:[],
				scrollOption: {
					step: 0.3, // 数值越大速度滚动越快
					limitMoveNum: 2, // 开始无缝滚动的数据量
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 2000 // 单步运动停止的时间(默认值1000ms)
				},
				
			}
		},
		methods:{
			initCarInstant(){
				let that = this
				getIndexCarInstant(this.carSelInfo.carid,this.carSelInfo.cartype).then(res =>{
					if(res.result == 0){
						if(res.carInstant != null){	
							that.carInfo = res.carInstant
							// that.carInfo.status = 
							that.handleOrientationStatus(that.carInfo)
						}						
					}else{
						this.$message({
							message: '未获取到机器人实时信息',
							type: 'error'
						});
					}
				})
			},
			handleWarn(warn){
				this.$alert("已读")
			},
			initCarDayWarning(){
				let that = this
				that.warningList = []
				that.awarningList = []
				that.bwarningList = []
				that.cwarningList = []
				getIndexCarWarning(this.carSelInfo.carid).then(res =>{
					if(res.result == 0){
						if(res.warningList != null && res.warningList.length > 0){
							that.warningList = res.warningList
							that.handleWarnLevel(that.warningList)
						}else{
							var warnnone = {
								carName:'无告警'
							}
							that.awarningList.push(warnnone)
						}					
					}else{
						this.$message({
							message: '未获取到车辆当日告警信息',
							type: 'error'
						});
						var warnnone = {
							carName:'无告警'
						}
						that.awarningList.push(warnnone)
					}
				})
			},
			
			initCarInfo(){
				let that = this
				getIndexCarCustom(this.carSelInfo.carid).then(res =>{
					if(res.result == 0){
						that.carpartsavaliable = res.carPartsAvaliable					
					}else{
						this.$message({
							message: '未获取到机器人运营概况信息',
							type: 'error'
						});		
					}
				})
			},
			mqttUpdateDataUsing(newData){
				var duration = newData.workDuration,milege = newData.workDistance,area = newData.workArea;
				if(this.carcustominfo != null){
					this.carcustominfo.duration = this.carcustominfo.duration+duration
					this.carcustominfo.milege = this.carcustominfo.milege+milege
					this.carcustominfo.workArea = this.carcustominfo.workArea+area
					this.carcustominfo.num = this.carcustominfo.num+1
				}
				if(this.carpartsavaliable != null){
					this.carpartsavaliable.masterBrushAvailable = this.carpartsavaliable.masterBrushAvailable-duration
					// this.carpartsavaliable.edgeBrushAvailable = this.carpartsavaliable.edgeBrushAvailable-duration
					this.carpartsavaliable.filterAvailable = this.carpartsavaliable.filterAvailable-duration
					this.carpartsavaliable.frontStallCoverAvailable = this.carpartsavaliable.frontStallCoverAvailable - duration
				}					
			},
			
			handleOrientationStatus(carInfo){
				var covarianceSta = '正常'
				let lngSta = carInfo.covarianceLngStatus,latSta = carInfo.covarianceLatStatus,heightSta = carInfo.covarianceHeightStatus
				if(lngSta == 0 || lngSta == 0 || heightSta == 0){
					 covarianceSta = ''
					if(lngSta == 0){
						covarianceSta += '经/'
					} 
					if(latSta == 0){
						covarianceSta += '纬/'
					}
					if(heightSta == 0){
						covarianceSta += '高'
					}
					covarianceSta += '度未使用'
				} 			
				this.carInfo.covarianceStatus = covarianceSta
			},
			
			handleWarnLevel(warningList){
				if(this.warningList.length <= 0){
					return
				}
				this.warningList.forEach((item,index)=>{
					var warn = item.info
					if(warn.indexOf('停车告警')>=0 || warn.indexOf('电池电压低') >=0){
						this.awarningList.push(item)
					}else if(warn.indexOf('垃圾箱容量不足告警')>=0 || warn.indexOf('清水箱不足') >=0 || warn.indexOf('作业即将完成') >=0){
						this.bwarningList.push(item)
					}else if(warn.indexOf('需要更换')>=0 ){
						this.cwarningList.push(item)
					}
				})
			},
			
			handleRealWarn(warn){
				var warninfo = warn.info
				var warnpayload = {
					carName:this.carSelInfo.carid,
					updateTime:warn.updateTime,
					info:warninfo
				}
				if(warninfo.indexOf('停车告警')>=0 || warninfo.indexOf('电池电压低') >=0){
					this.awarningList.push(item)
				}else if(warninfo.indexOf('垃圾箱容量不足告警')>=0 || warninfo.indexOf('清水箱不足') >=0 || warninfo.indexOf('作业即将完成') >=0){
					this.bwarningList.push(item)
				}else if(warninfo.indexOf('需要更换')>=0 ){
					this.cwarningList.push(item)
				}	
			}
			// 停止定时器
			// clearCarInfo() {
			// 	clearInterval(this.carInfoIntervalId); //清除计时器
			// 	this.carInfoIntervalId = null; //设置为null
			// }
		}
	}
</script>

<style  lang="scss" scoped>
	.container{
		z-index: 10;
		position: fixed;
		top:10%;
		left:.2rem;
		width: 20%;
		display: flex;
		flex-direction: row;
		color: #fff;
		font-size: 20px;
		text-align: center;
	}
	
	.car_instant{
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		.item{		
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			background:rgba(22,26,99,.7);
			.tit{
				padding:.08rem;
				font-size: .15rem;
				border-bottom:.02rem solid #19F2EB;
				text-align: left;
			}
			.info{
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				font-size: .12rem;
				.datachart{
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					padding:.1rem .2rem;
					.dataimg{
						align-self: center;
						height: 0.25rem;
						padding-right:.15rem;
					}
					.data{
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						line-height: .25rem;
						
						.fontw{
							color:#fff
						}
						
						.fontg{
							color:#19F2EB
						}
					}
				}
				.data2{
					display: flex;
					flex-direction: row;
					justify-content: space-evently;
					line-height: .25rem;
					
					.datanum{
						padding-left: 0.5rem;
					}
				}
			}
			
		}
		
		.car_work{
			display: flex;
			flex-direction: row;
			.box{
				overflow: hidden;
				position: relative;
				z-index: 10;
				width: 4rem;
				height: 2rem;
				padding-left: .15rem;
			}
			.boxnav {
			  text-align: center;
			  white-space: nowrap;
			  // height:calc(100% - .4rem); 
			  display: flex;
			  flex-direction: row;
			  justify-content: space-between;
			  align-items: center;
			  padding: .12rem 0;
			}			
			.boxitem {
			  margin: auto; 
			  text-align: left;
			  text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本*/
			  white-space: nowrap; /* 不换行 */
			  overflow: hidden; 
			  // width:1.5rem;
			  font-size: .15rem;
			}
			.row{
				display: flex;
				flex-direction: row;
				justify-content: center;
			}
		}
	}
	
</style>
